export const AMOUNT_TYPE = {
    amount: 1,
    free: 2,
};

export const PAYMENT_METHOD_TYPE = {
    free: 3,
};
